<div class="csv-header">
  <span class="csv-header__icon" aria-hidden="true">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M14 3v5h5M8.5 12.5h7M8.5 16h7M12 12.5V19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
  </span>
  <div class="csv-header__copy">
    <h5 class="csv-header__title">Import story prompts</h5>
    <p class="csv-header__subtitle" *ngIf="step === 'pick'">Upload a CSV. You'll choose which column holds your prompts next.</p>
    <p class="csv-header__subtitle" *ngIf="step !== 'pick'">{{file?.name}}</p>
  </div>
  <button type="button" class="csv-header__close" (click)="close()" [disabled]="isBusy" aria-label="Close">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
  </button>
</div>

<!-- Step 1: choose a file -->
<div class="csv-body" *ngIf="step === 'pick'">
  <div class="prompt-csv-drop" [class.prompt-csv-drop--active]="isDragging"
    (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 16V5M7.5 9.5 12 5l4.5 4.5M5 20h14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <p class="prompt-csv-drop__title">Drop a CSV file here</p>
    <p class="prompt-csv-drop__text">Any layout works. One prompt per row.</p>
    <button (click)="csvInput.click()" type="button" class="csv-btn csv-btn--primary" [disabled]="isBusy">
      <i *ngIf="isBusy" class="fas fa-spinner fa-pulse"></i>
      {{isBusy ? 'Reading file…' : 'Choose CSV file'}}
    </button>
    <input #csvInput type="file" accept=".csv,text/csv" hidden (change)="onFileSelected($event)">
  </div>
</div>

<!-- Step 2: map columns -->
<div class="csv-body" *ngIf="step === 'map' && preview">
  <label class="prompt-csv-header-toggle">
    <input type="checkbox" [(ngModel)]="hasHeader">
    <span>First row has column names</span>
  </label>

  <div class="prompt-csv-map">
    <div class="prompt-csv-map__row">
      <label class="prompt-csv-map__label" for="map-prompt">Prompt <span class="prompt-csv-map__required">Required</span></label>
      <select id="map-prompt" class="prompt-csv-map__select" [(ngModel)]="promptColumn">
        <option [value]="notMapped" disabled>Choose a column</option>
        <option *ngFor="let column of columns; trackBy: trackByValue" [value]="column.value">{{column.label}}</option>
      </select>
    </div>
    <div class="prompt-csv-map__row">
      <label class="prompt-csv-map__label" for="map-audience">Audience <span class="prompt-csv-map__hint">Users, Guests, or Both</span></label>
      <select id="map-audience" class="prompt-csv-map__select" [(ngModel)]="audienceColumn">
        <option [value]="notMapped">Don't import — use the setting below</option>
        <option *ngFor="let column of columns; trackBy: trackByValue" [value]="column.value">{{column.label}}</option>
      </select>
    </div>
    <div class="prompt-csv-map__row">
      <label class="prompt-csv-map__label" for="map-active">Active <span class="prompt-csv-map__hint">Yes or No</span></label>
      <select id="map-active" class="prompt-csv-map__select" [(ngModel)]="activeColumn">
        <option [value]="notMapped">Don't import — new prompts are active</option>
        <option *ngFor="let column of columns; trackBy: trackByValue" [value]="column.value">{{column.label}}</option>
      </select>
    </div>
  </div>

  <div class="prompt-csv-default">
    <p class="prompt-csv-default__label">
      {{audienceColumn === notMapped ? 'Who can be asked these prompts?' : 'When the audience cell is blank'}}
    </p>
    <div class="prompt-csv-default__options" role="radiogroup">
      <label class="prompt-csv-default__option" *ngFor="let option of audienceOptions"
        [class.prompt-csv-default__option--selected]="defaultAudience === option.value">
        <input type="radio" name="defaultAudience" [value]="option.value" [(ngModel)]="defaultAudience">
        <span>{{option.label}}</span>
      </label>
    </div>
  </div>

  <div class="csv-sample prompt-csv-preview">
    <div class="csv-sample__head">
      <span>Preview</span>
      <span class="prompt-csv-preview__count">{{dataRows.length}} {{dataRows.length === 1 ? 'row' : 'rows'}}</span>
    </div>
    <table>
      <thead>
        <tr><th>Prompt</th><th class="prompt-csv-preview__narrow">Audience</th><th class="prompt-csv-preview__narrow">Active</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of previewRows" [class.prompt-csv-preview__skip]="!!row.problem">
          <td>
            <span [class.prompt-csv-preview__empty]="!row.prompt">{{row.prompt || 'Empty'}}</span>
            <span class="prompt-csv-preview__problem" *ngIf="row.problem">Skipped: {{row.problem}}</span>
          </td>
          <td class="prompt-csv-preview__narrow" [class.prompt-csv-preview__muted]="row.audienceIsDefault">{{row.audience}}</td>
          <td class="prompt-csv-preview__narrow" [class.prompt-csv-preview__muted]="row.active === '—'">{{row.active}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="prompt-csv-warn" *ngIf="check.skipped.length">
    <p class="prompt-csv-warn__title">{{check.skipped.length}} {{check.skipped.length === 1 ? 'row' : 'rows'}} will be skipped</p>
    <ul class="prompt-csv-warn__list">
      <li *ngFor="let row of check.skipped">Line {{row.line}}: {{row.problem}}</li>
    </ul>
  </div>

  <p class="csv-info">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66M20 4v4.5h-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>
      Prompts that already exist are not added twice. If a row gives one a new audience, the existing prompt is updated to cover it.
      <ng-container *ngIf="activeColumn === notMapped">New prompts are added as active; prompts that already exist keep their current Active setting.</ng-container>
      <ng-container *ngIf="activeColumn !== notMapped">A blank Active cell (—) adds new prompts as active and leaves existing ones as they are.</ng-container>
    </span>
  </p>
  <p class="prompt-csv-error" *ngIf="mappingError">{{mappingError}}</p>
</div>

<!-- Step 3: results -->
<div class="csv-body" *ngIf="step === 'done' && result">
  <div class="prompt-csv-stats">
    <div class="prompt-csv-stat prompt-csv-stat--good">
      <strong>{{result.created}}</strong>
      <span>added</span>
    </div>
    <div class="prompt-csv-stat">
      <strong>{{result.updated}}</strong>
      <span>updated</span>
    </div>
    <div class="prompt-csv-stat">
      <strong>{{result.unchanged}}</strong>
      <span>already up to date</span>
    </div>
    <div class="prompt-csv-stat" [class.prompt-csv-stat--warn]="result.skipped.length">
      <strong>{{result.skipped.length}}</strong>
      <span>skipped</span>
    </div>
  </div>

  <div class="csv-sample prompt-csv-skipped" *ngIf="result.skipped.length">
    <div class="csv-sample__head"><span>Skipped rows</span></div>
    <table>
      <thead>
        <tr><th class="csv-sample__num">Row</th><th>Prompt</th><th>Reason</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of result.skipped">
          <td class="csv-sample__num">{{item.row}}</td>
          <td>{{item.prompt || '—'}}</td>
          <td>{{item.reason}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p class="csv-muted" *ngIf="result.skipped.length">Fix these rows and import the file again. Prompts that were already saved will not be duplicated.</p>
</div>

<div class="csv-footer">
  <ng-container *ngIf="step === 'pick'">
    <button (click)="close()" type="button" class="csv-btn csv-btn--ghost" [disabled]="isBusy">Cancel</button>
  </ng-container>
  <ng-container *ngIf="step === 'map'">
    <button (click)="startOver()" type="button" class="csv-btn csv-btn--ghost" [disabled]="isBusy">Choose another file</button>
    <button (click)="importPrompts()" type="button" class="csv-btn csv-btn--primary" [disabled]="isBusy || !!mappingError">
      <i *ngIf="isBusy" class="fas fa-spinner fa-pulse"></i>
      {{isBusy ? 'Importing…' : 'Import ' + promptCount + (promptCount === 1 ? ' prompt' : ' prompts')}}
    </button>
  </ng-container>
  <ng-container *ngIf="step === 'done'">
    <button (click)="startOver()" type="button" class="csv-btn csv-btn--ghost">Import another file</button>
    <button (click)="close()" type="button" class="csv-btn csv-btn--primary">Done</button>
  </ng-container>
</div>
